module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch01"
    }
  }, [_c('a', {
    attrs: {
      "id": "page09"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Chapter One")])])])])]), _c('div', {
    staticClass: "chapterBody"
  }, [_c('a', {
    attrs: {
      "id": "page09"
    }
  }, [_c('p', {
    staticClass: "chapterOpenerText",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("He was coming for her.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The now-familiar ache of dread crept through her body as Maggie Reyes traced her finger around the photo of the smilng girl’s face—a photo that now graced the front page of the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Monterey County Herald")]), _vm._v(" with the words "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("victim")]), _vm._v(" and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("homicide")]), _vm._v(" buried in the caption. Four murders in four states in four months. And now he was only minutes away.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Why don’t you run?")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page09"
    }
  }, [_vm._v("Maggie placed her palms flat on her desk and pushed herself up to a standing position. It was funny, even though her head was telling her to run and the fear in her heart robbed her of sleep every night, that odd sense of security she always felt in her cousin Esme’s Monterey beach home was still there. Raising her eyes to the map of the United States above her, Maggie fished a red-tipped thumbtack out of the wooden caddy meticulously placed in the upper left corner of the desk. Little Rock. St. Louis. Denver. All three cities had red tacks plunged through the center of their black dots on the map. And they had fat, ")]), _c('a', {
    attrs: {
      "id": "page10"
    }
  }, [_vm._v("corresponding files in the metal cabinet to her left, filled with articles from the dozens of newspapers she subscribed to, printouts from database searches, posts from a few true-crime listservs and other odds and ends pertaining to the cases. In one swift motion, Maggie pushed the fourth tack through Carmel-by-the-Sea, California, releasing the breath she’d been holding as she did so.")])]), _c('a', {
    attrs: {
      "id": "page10"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Carmel, sister city to Monterey, which she now called home.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Do you wanna live forever, Maggie?")])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Ignoring the persistent whisper inside her head, she turned her back on the map and padded across the plush Berber rug to the window seat in what she had come to think of as “her” office, where she could watch the white-capped waves break against the jagged black rocks jutting up toward the sky like sentinels. Monterey, California, was a beautiful, sunny city, except for in a few areas along the water that had their own peculiar micro-climates. The house Maggie lived in lay smack in the middle of one of them and was always enveloped in fog and mist. Not that it really mattered.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page10"
    }
  }, [_vm._v("Folding herself into the small nook, she leaned against a wooden support and dug her bare toes into the brocade seat cushion. Her gaze wandered farther down the beach, past the point where the black rocks and dark, foamy water abruptly ended and a few intrepid surfers were paddling toward the horizon in search of the next big wave. Thinking of the wet suit that hadn’t seen action since the late ’90s, she listened ")]), _c('a', {
    attrs: {
      "id": "page11"
    }
  }, [_vm._v("to the muffled roar of the ocean and watched the surfers for what felt like fifteen minutes. When at last she glanced at the glowing red numbers of the digital clock on her desk, she found it was three-thirty. It had been over two hours.")])]), _c('a', {
    attrs: {
      "id": "page11"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("How time flies when you’re stuck at home with no place to go.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Or when you’re avoiding something.")]), _vm._v(" Maggie’s fingers toyed with the slight fringe around the hole in the knee of her jeans. Gee, fringe. That could keep her busy for half a day if she let it.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("And that was the thing. She couldn’t let it anymore. Four killings in four months, and every single one of them weighing on her conscience like stone. And now he was coming for her.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("And now there was no one to call, nowhere to run. Esme was safe in her other home in Seattle, and Maggie had left her family in New Orleans, safe in their complete ignorance of her whereabouts. She routed letters through Esme to her parents or risked the occasional phone call through her alias Mary Smythe’s long-distance account, but that was all the communication she’d risk. Not the ideal arrangement, but there was no way she wanted anyone close to her in danger.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page11"
    }
  }, [_vm._v("But now the impulse to bolt out the door and run for home as far and as fast as she could was almost overpowering. Almost. But once upon a time, she’d been a cop, not the silly caretaker of her rich cousin’s beach house. And she would have laughed if anyone had told her she’d be hiding thousands of miles away ")]), _c('a', {
    attrs: {
      "id": "page12"
    }
  }, [_vm._v("from her Louisiana home—in California, of all places—with blond hair and an assumed name. Mary Smythe-with-a-Y. She snorted as she rose from the window seat. At least she could have had the where-withal to choose something more glamorous. She walked into the hallway and caught a glimpse of herself in the antique mirror hanging near the front door. Thank God she’d asked Adriana for a box of Revlon Rich Auburn-Black 22 when she’d made out this week’s grocery list. The color suited her skin tone; she was never meant to be a blond.")])]), _c('a', {
    attrs: {
      "id": "page12"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Taking a deep breath, Maggie turned her head, gripped the brass handle of the ornate wooden door. With one push of her finger, one swing of her arm, she could be outside, just a mile away from sunshine and people walking their dogs, hand-dipped ice cream and a real bookstore. Only three miles away from the Monterey police station, ten from the gruesome murder she’d just read about in the papers.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Her hand started to shake, just a slight tremor, and she closed her eyes. One push, one swing. She had a job to do, and after a year and a half of insanity, she was going to do it. If anyone was going to stop the Surgeon’s murdering spree, they were going to need her. It was time for Miss Mary Smythe to stop being the crazy woman on the beach, time for her to rejoin the living, time for her to be fearless Maggie Reyes again.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Maggie pushed, Maggie swung.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page12"
    }
  }, [_vm._v("And a hurricane-grade wind lashed through the hall. It whipped around the mirror, toppled the coat ")]), _c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_vm._v("tree, sent the car keys that hung unused on a small nail crashing to the floor.")])]), _c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Oh, God!” Maggie gasped, and then she couldn’t breathe, couldn’t think. Something was wrapping itself around her neck, strangling her, and she clawed at her throat with frantic hands, trying to loosen whatever it was so she could breathe again. Tighter and tighter and tighter, until all she could see was black.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Her knees crashed to the hardwood floor, and she groped blindly outward until she felt the doorjamb beneath her fingers. Her other hand swung out and connected with the open door. The pressure on her windpipe eased a little, just enough for her to take one last gasp and use the tiny trickle of energy it gave her to heave the door closed.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She could still hear her own heartbeat, thundering in her ears while she took deep, gasping gulps of air. The invisible hands gently caressed her throat as they uncoiled, reminding her that they were still there. Waiting. And then they were gone.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_vm._v("Shaking, she turned her body around until she was sitting on the floor, her back leaning against the door, barring it from ever opening again and sending her tattered remains of sanity whirling out with the afternoon breeze. She rested her hands on her knees, watching as the tremors slowed, and then stopped. Listened to her heart return to its normal pattern, her breathing slow to a smooth, almost meditative rhythm. Her eyes darted to the coat tree standing straight and tall in the hallway corner; her keys hung ")]), _c('a', {
    attrs: {
      "id": "page14"
    }
  }, [_vm._v("on their nail by the mirror, undisturbed. Welcome to the grand delusion.")])]), _c('a', {
    attrs: {
      "id": "page14"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("A single chime from the grandfather clock that shared the hallway with her was all it took to completely bring her back to the land of the living.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Four-thirty. She had a half hour before the police detective Adriana had recommended went home for the day.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Better try the phone, Miss Mary")])]), _vm._v(" "), _c('p', {
    staticClass: "spaceBreak",
    staticStyle: {
      "text-indent": "0%"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("M"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("AGGIE WAS STILL")]), _vm._v(" sitting on the floor, cordless phone in hand, when the knock came. Darn. She knew she’d stayed on the phone too long leaving her “anonymous tip” with the Monterey police. Of course they’d traced it to her alias Mary Smythe’s account and were coming to ask her questions. The last thing she wanted was to be dealing with their questions—the same kind that had sent her spiraling down into her mad, mad world in the first place. Maybe if she just sat there and made herself as small and still as she could, the cops would go away.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Another knock came, harder and more insistent this time. Maggie gently put the phone on the ground and hugged her knees to her chest. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Just go away. Just leave me alone.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page14"
    }
  }, [_vm._v("No such luck. The next knock rattled her bones through the solid wood of the door. “Oh, go have a doughnut,” she mumbled, though she flexed her legs and slid her spine upward along the wall until she was standing. Resigning herself to the fact that she ")]), _c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_vm._v("would have to face the police sooner or later, she turned to look through the peephole.")])]), _c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Odd. Rather than the casual business attire most of Monterey’s finest preferred, the man on her doorstep wore faded jeans and a dusty-blue T-shirt with the words "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Got Mojo?")]), _vm._v(" scrawled across his broad back in white letters.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Charming,” she muttered, then cupped her hands around her mouth. “Got ID?” she shouted through the door.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He turned, shoulders arched back with the easy grace of an athlete, and Maggie sucked in a breath. Okay, so maybe the man had a little mojo. His still, gray eyes narrowed, and a corner of his mouth turned upward in an amused smirk, further accentuated by the pronounced bow-shaped curve to his upper lip. Okay, so he was cute. Being a white male between the ages of 30 and 35, the guy was also solidly in the demographic that included most of your average serial killers.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Which was not something Maggie took lightly anymore.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She watched him reach behind him to grab something out of his back pocket—and jumped back in surprise when his wallet smacked against the peephole, obliterating the tiny spot of light that usually shone through the door.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He drew the wallet back, and she moved closer once again, giving his badge—all she could see given her limited range of vision—as thorough a once-over as she could.")])]), _c('a', {
    attrs: {
      "id": "page16"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I’m looking for Mary Smythe.” His voice was low and soft, even through the door, but with the faintest rough edge to it. Politely dangerous. It didn’t sound familiar, but then, there was a lot about her past that she’d worked hard to block out of memory.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Maggie leaned her forehead against the door, weighing her options. Would the Surgeon knock on her door in broad daylight? Improbable, given his preference for nighttime ambushes and drugs that stole your ability to reason.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The thought nearly caused Maggie to slide to the floor once more, but then she realized that there was no way the man on her doorstep could compare to the monsters inside her head, anyway. She’d never been afraid to face a threat head-on—it was living in constant fear of being watched, taken by surprise, attacked from behind that made her crazy. With a defiant snap of her wrist, she shot back the deadbolt and opened the door, careful to keep it between her body and the outside world. As soon as he’d stepped into the entryway, she pushed it shut again. And exhaled.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He didn’t say a word once they were face-to-face, almost scowling as he gave her a thorough scrutinizing with those pale gray eyes of his. Apparently, she’d surprised him by not being seventy-something, with rollers in her hair and twenty cats sweeping around her ankles. But he quickly got his face under control, shoving a hand through his thick brown hair so it spiked slightly.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page16"
    }
  }, [_vm._v("“So. You must be James Brentwood, then,” she said a little too loudly, folding her arms and widening ")]), _c('a', {
    attrs: {
      "id": "page17"
    }
  }, [_vm._v("her eyes in an attempt to look as unhinged as possible. One good thing about being the crazy woman on Mermaid Point—no one expected you to waste time with social graces. And they usually were only too happy to leave you alone as soon as possible.")])]), _c('a', {
    attrs: {
      "id": "page17"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“That’s right.” He quickly flashed his badge once more, then folded up the wallet and jammed it into his back pocket. “Ma’am. I’m sorry to bother you, but I’m here about an anonymous phone call placed from this location at 4:37 p.m.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("A short silence stretched between them as they each pondered their next moves, like two grand masters over a chessboard. Maggie circled around him and took her time picking the cordless phone off the floor, placing it back in its cradle while her eyes darted ever so briefly to the panic button on her security system’s white keypad. “I thought the point of leaving an anonymous tip was that one remained anonymous,” she finally said.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Usually,” he said. “But not with something like this, ma’am.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I’m not much older than you, so if you don’t stop ma’am-ing me, I might be forced to start screaming like a lunatic, right here, right now.” To her satisfaction, he blinked, apparently wondering whether or not she was serious. Good. Best to keep him on edge so she had the advantage. She so needed to remain in control of this conversation.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("It didn’t take him long to recover. “I’ll call you Sheena, Queen of the Jungle, if it helps you answer my questions,” he said.")])]), _c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Spare me your fantasies. Mary will do.” Well. Obviously she hadn’t made him "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("that")]), _vm._v(" uncomfortable. “So you’re Brentwood, the one I talked to on the phone?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("At his nod, she motioned him ahead of her, into the spacious kitchen just beyond the entryway. “Come in. I was going to make coffee.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Nice place.” The man’s eyes skimmed over the room’s pale wood cabinets, ceramic tiles, and state-of-the-art steel appliances. A little too minimalist Pottery Barn for her taste, but she couldn’t be picky when Esme was willing to put a roof with an ocean view over her unproductive head.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The rest of Brentwood’s body remained almost preternaturally still. And despite the badge, the cop’s attention to detail, the standard issue semi-automatic Glock prominently displayed in the shoulder holster, Maggie felt the hair on the back of her neck prickle.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Maybe it was just the small gold hoop in his left ear, maybe it was the too-casual clothes, the too-relaxed stance, but she couldn’t shake the feeling that something was really, really wrong here.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("He’s a cop, Reyes. Get a grip,")]), _vm._v(" she chided herself. However, the thought wasn’t enough to keep her from casually sidling to the left so the large kitchen island was between them. She gestured for him to sit down…in the chair farthest from her.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_vm._v("“Well, Mary, you mind if we get started?” he asked. The hoarse quality to his voice made the mundane phrase sound almost X-rated. And that was a ")]), _c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_vm._v("little too much for a healthy woman in her early 30s who had been celibate for…way too long.")])]), _c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Even so, her overactive hormones weren’t quite enough to make her overlook the absence of an evidence-gathering notebook in his hands.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“So. Coffee, Officer Brentwood?” she asked, taking the glass pot out of the coffeemaker to her right and filling it up with water. “Adriana brought some Kona beans from her last trip to Hawaii. I haven’t tried it yet, but she says it’s wonderful.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Adriana’s your neighbor?” he asked.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Maggie glanced out the windows, past the patio she never used, and watched the waves break against the rocks for a moment. “A friend,” she murmured, biting her lower lip. The rush of cool water over the hand holding the pot brought her attention back to her task.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Mary, I don’t want to be rude…”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Here it comes.")])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“…but you said on the phone you believe a serial killer called the Surgeon might have left his New Orleans territory and is on his way to Monterey. Since that’s all you felt like telling us, I’m here to find out what gave you that impression.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Reaching for the blue ceramic sugar canister, Maggie undid the metal clasp and peeled the sealed lid back, stuffing her hand inside. Out of the corner of her eye, she saw that the man had stood and was leaning against the table, facing her. “I’m sorry, officer. I don’t mean to waste your time—”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_vm._v("With that, Maggie pulled her hand out of the can")]), _c('a', {
    attrs: {
      "id": "page20"
    }
  }, [_vm._v("ister and swung around. She switched off the safety of her Firestar M43 and aimed the small gun right for his mojo-covered heart. “But if you’re James Brentwood, then I really am Sheena, Queen of the Jungle.”")])]), _c('a', {
    attrs: {
      "id": "page20"
    }
  })]), _c('a', {
    attrs: {
      "id": "page20"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page20"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ff35a1a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781459237469_ch01.vue
// module id = 84
// module chunks = 0